import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AccountCircle } from "@material-ui/icons";
import { Typography, AppBar, Toolbar, Box } from "@material-ui/core";
import { ReactComponent as GentrackLogo } from "./gentrack-logo.svg";
import { Link } from "react-router-dom";
import { useAuthenticatedUserContext } from "../../features/Auth/UserProvider";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
}));

export const AppHeader = () => {
  const classes = useStyles();

  const { user } = useAuthenticatedUserContext();

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Box>
            <Link to={"/"}>
              <GentrackLogo />
            </Link>
          </Box>
          <Box flexGrow={1} />
          {user && (
            <Box display="flex" alignItems="center">
              <Typography>{user.name}</Typography>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height={48}
                width={48}
                lineHeight={1}
              >
                <AccountCircle />
              </Box>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};
